export const HANDLE_RESPONSE_DEALS = 'page/mydeals/HANDLE_RESPONSE_DEALS';
export const OPEN_MODAL = 'page/mydeals/OPEN_MODAL';
export const CLOSE_MODAL = 'page/mydeals/CLOSE_MODAL';
export const SET_DEAL_IS_SCHEDULING = 'page/mydeals/SET_DEAL_IS_SCHEDULING';
export const SET_FORM_VALUES = 'page/mydeals/SET_FORM_VALUES';
export const HANDLE_RESPONSE_APPOINTMENT =
  'page/mydeals/HANDLE_RESPONSE_APPOINTMENT';
export const CLEAR_FORM = 'page/mydeals/CLEAR_FORM';
